// 滚动位置管理工具
class ScrollManager {
  constructor() {
    this.storageKey = 'scroll_positions';
    this.maxAge = 30 * 60 * 1000; // 30分钟
  }

  // 保存滚动位置
  saveScrollPosition(routeKey, scrollY) {
    try {
      const positions = this.getAllPositions();
      positions[routeKey] = {
        scrollY: scrollY,
        timestamp: Date.now()
      };
      localStorage.setItem(this.storageKey, JSON.stringify(positions));
    } catch (e) {
      console.log('保存滚动位置失败:', e);
    }
  }

  // 获取滚动位置
  getScrollPosition(routeKey) {
    try {
      const positions = this.getAllPositions();
      const position = positions[routeKey];
      
      if (position) {
        const now = Date.now();
        if (now - position.timestamp < this.maxAge) {
          return position.scrollY;
        } else {
          // 删除过期的位置记录
          delete positions[routeKey];
          localStorage.setItem(this.storageKey, JSON.stringify(positions));
        }
      }
      return 0;
    } catch (e) {
      console.log('获取滚动位置失败:', e);
      return 0;
    }
  }

  // 获取所有保存的位置
  getAllPositions() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : {};
    } catch (e) {
      console.log('获取所有滚动位置失败:', e);
      return {};
    }
  }

  // 清除所有滚动位置
  clearAllPositions() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {
      console.log('清除滚动位置失败:', e);
    }
  }

  // 清除特定路由的滚动位置
  clearPosition(routeKey) {
    try {
      const positions = this.getAllPositions();
      delete positions[routeKey];
      localStorage.setItem(this.storageKey, JSON.stringify(positions));
    } catch (e) {
      console.log('清除特定滚动位置失败:', e);
    }
  }

  // 获取当前滚动位置
  getCurrentScrollY() {
    return window.scrollY || window.pageYOffset || 0;
  }

  // 滚动到指定位置
  scrollToPosition(scrollY, smooth = false) {
    if (smooth) {
      window.scrollTo({
        top: scrollY,
        behavior: 'smooth'
      });
    } else {
      window.scrollTo(0, scrollY);
    }
  }

  // 滚动到顶部
  scrollToTop(smooth = false) {
    this.scrollToPosition(0, smooth);
  }

  // 滚动到底部
  scrollToBottom(smooth = false) {
    const scrollY = document.documentElement.scrollHeight - window.innerHeight;
    this.scrollToPosition(scrollY, smooth);
  }
}

// 创建全局实例
const scrollManager = new ScrollManager();

export default scrollManager; 


// WEBPACK FOOTER //
// ./src/common/scrollManager.js